// extracted by mini-css-extract-plugin
export var hideEditor = "_i2-2";
export var infoIcon = "_i2-3";
export var label = "_i2-1";
export var labelContainer = "_i2-0";
export var readonlyText = "_i2-4";